export const SAMPLE_PROMPTS = [
  {
    label: "Startup Runway Calculator",
    prompt: "Build a simple startup runway calculator, which takes the burn per month, current cash and display the runway in months",
  },
  {
    label: "Expense tracking app",
    prompt: "Budget tracker with reports and graphs",
  },
  {
    label: "Procurement planning app",
    prompt: "Build a procurement planning application",
  },
  {
    label: "Invoice generator",
    prompt: "Build Invoice generator application. Take the fields in a form and show a nice looking invoice preview, give an option to export to PDF",
  },
  {
    label: "Budget tracker",
    prompt: "Create a budget tracker application with ability to view, store, manage transactions CRUD all from a transaction list page.",
  },
];

export const AGENT_SAMPLE_PROMPTS = [
  {
    label: "Invoice Processing Agent",
    prompt: "Create an agent that automatically extracts data from invoice PDFs, validates amounts, and flags discrepancies for review",
  },
  {
    label: "Expense Categorization Agent",
    prompt: "Build an agent that analyzes expense descriptions and automatically categorizes them with confidence scores",
  },
  {
    label: "Payment Reminder Agent",
    prompt: "Create an agent that monitors overdue invoices and sends automated payment reminders to customers",
  },
  {
    label: "Budget Alert Agent",
    prompt: "Build an agent that tracks department spending and sends alerts when budgets are close to limits",
  },
  {
    label: "Receipt Validator Agent",
    prompt: "Create an agent that verifies expense receipts against company policy and flags non-compliant submissions",
  },
];

export const WORKFLOW_SAMPLE_PROMPTS = [
  {
    label: "Invoice Approval Workflow",
    prompt: "Create a workflow for invoice approval that routes to managers based on amount thresholds and department",
  },
  {
    label: "Expense Reimbursement Flow",
    prompt: "Build a workflow that processes employee expense submissions through approval, validation, and payment stages",
  },
  {
    label: "Purchase Order Workflow",
    prompt: "Create a workflow for purchase order creation, approval routing, vendor notification, and tracking",
  },
  {
    label: "Month-End Close Workflow",
    prompt: "Build a workflow that orchestrates month-end financial close tasks with automated checks and notifications",
  },
  {
    label: "Vendor Onboarding Flow",
    prompt: "Create a workflow for new vendor registration, document verification, compliance checks, and activation",
  },
];

export const APP_SAMPLE_PROMPTS = [
  {
    label: "Task Manager",
    prompt: "Build a simple TODO application with ability to create, edit, delete, and mark tasks as complete.",
  },
  {
    label: "Budget Tracker",
    prompt: "Build a simple budget tracker app that lets users add income and expenses, and a summary screen with totals",
  },
  {
    label: "Expense Management",
    prompt: "Create a simple expense management application to allow users to manage, auto-categorize and track their expense transactions.",
  },
  {
    label: "Project Management",
    prompt: "Build a project management application with ability to CRUD tasks & projects. Along with team member login, task assignment and project dashboards.",
  },
  {
    label: "Customer CRM",
    prompt: "Build a customer relationship management application for tracking leads, contacts, deals.",
  },
];

export const SHOWCASE_APPS = [
  {
    id: 9,
    title: "Tax Calculator",
    description: "Calculate taxes with real-time updates",
    image: "/app-images/tax-calculator.png",
    slug: "tax-calculator",
    category: "Tax",
  },
  {
    id: 2,
    title: "Invoice Generator",
    description: "Create professional invoices with PDF export capability",
    image: "/app-images/invoice-generator.png",
    slug: "invoice-generator",
    category: "Billing",
  },
  {
    id: 1,
    title: "Startup Runway Calculator",
    description: "Track burn rate and cash runway with real-time projections",
    image: "/app-images/startup-runway.png",
    slug: "startup-runway",
    category: "Analytics",
  },
  {
    id: 3,
    title: "Budget Tracker",
    description: "Monitor spending with beautiful charts and insights",
    image: "/app-images/budget-tracker.png",
    slug: "budget-tracker",
    category: "Budgeting",
  },
  {
    id: 4,
    title: "Loan Calculator",
    description: "Calculate loans with detailed amortization schedules",
    image: "/app-images/loan-calculator.png",
    slug: "loan-calculator",
    category: "Calculator",
  },
  {
    id: 5,
    title: "Cash Flow Forecast",
    description: "Predict future cash positions with AI insights",
    image: "/app-images/cash-forecast.png",
    slug: "cash-forecast",
    category: "Forecasting",
  },
  {
    id: 6,
    title: "Procurement Planning",
    description: "Streamline procurement with smart planning tools",
    image: "/app-images/procurement-planning.png",
    slug: "procurement-planning",
    category: "Operations",
  },
  {
    id: 7,
    title: "Sales Forecasting",
    description: "AI-powered sales predictions and analytics",
    image: "/app-images/sales-forecasting.png",
    slug: "sales-forecasting",
    category: "Sales",
  },
  {
    id: 8,
    title: "IT Services Manager",
    description: "Manage IT services and support tickets efficiently",
    image: "/app-images/it-services.png",
    slug: "it-services",
    category: "Services",
  },
];
